var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTtgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "TTG_Color_Fill_1_Image",
    "data-name": "TTG + Color Fill 1\\xA0Image",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 3511.65 384.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#10284a;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3495.46,234.91l15.76-26q43-70.9,85.86-141.85c2-3.22,4-4.82,7.85-4.54,5.11.36,10.26.09,15.72.09V346.19h-12.33V80.46L3607,80l-111.6,180.1L3384,80.31l-.94.18v265.7h-13.51c-.09-1.83-.27-3.58-.27-5.33q0-136.21-.11-272.44c0-4.56,1.33-5.4,5.76-6,12-1.7,18.36,3.26,24.47,13.63,30.26,51.35,61.5,102.11,92.4,153.08C3492.86,230.79,3493.93,232.45,3495.46,234.91Z",
    transform: "translate(-109 -12.63)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3015.6,110.83c-17-18.67-37.77-30.28-61.78-36.36-76.39-19.34-148.28,29.79-158,107.84-4.15,33.17-.35,65.07,16.58,94.2,25,42.95,63.17,63.64,112.67,62.71,31.45-.59,58.45-12.89,81.7-33.86a12.51,12.51,0,0,0,4.42-10.39c-.21-22-.1-44-.1-66v-5.89H2894.49V210.61h129.43c.13,1.84.34,3.6.35,5.36,0,28.66.1,57.33-.14,86a12.93,12.93,0,0,1-3.33,8.22c-31.73,31.95-70.33,45.13-114.91,41-66-6.14-117.23-56.44-124.93-125.7-4.57-41.06,2.68-79.48,28-113,26.61-35.18,62.81-52.57,106.59-54.38,40.47-1.67,75.64,11.11,104.78,39.61,1,.94,1.89,1.89,2.82,2.85a12.77,12.77,0,0,1,.86,1.27Z",
    transform: "translate(-109 -12.63)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1923.38,224.06l87.21,122.39c-5.95,0-10.91.31-15.79-.18-1.51-.15-3-2.32-4.14-3.87q-40-56.79-79.83-113.7c-2.4-3.42-4.79-5.06-9.25-5-18.83.31-37.67.13-56.5.13h-5.86V346.09h-13v-283a14.17,14.17,0,0,1,2.5-.42c34.5.09,69.06-1.14,103.47.66,46.81,2.46,78.89,37.35,74.23,89-3.77,41.85-34.13,68.75-77.57,71.45Zm-84-13.27a19,19,0,0,0,2.62.38c29.14,0,58.3.28,87.43-.27a61.83,61.83,0,0,0,39.42-15c18.91-16,25.3-37.15,23-60.95-2.52-25.72-15.36-45-40-54.42-9.25-3.53-19.72-5-29.7-5.32-25.79-.72-51.62-.24-77.43-.23-1.76,0-3.51.19-5.35.29Z",
    transform: "translate(-109 -12.63)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2399.73,62.92h172.54v12H2413.33V194h155.94v12.83H2413.15v127h159.09v12.43c-1.72.11-3.48.31-5.24.31-54,0-108,0-162,.11-4.34,0-5.64-1.07-5.63-5.55q.2-136.5.11-273C2399.48,66.46,2399.63,64.84,2399.73,62.92Z",
    transform: "translate(-109 -12.63)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1177.31,346.17V69.33c0-6.7,0-6.71,6.78-6.71q79,0,158,0c9,0,8.3-1.65,8.31,8.69,0,1-.19,2-.35,3.47H1191.3V194h155.88v12.68h-155.9V333.9h158.78v12.27Z",
    transform: "translate(-109 -12.63)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M3124.92,206.69V333.85h158.81v12.21H3111.44V63h172.3V74.88H3125.11V194h155.68v12.65Z",
    transform: "translate(-109 -12.63)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M861.29,63.39a3.94,3.94,0,0,1,.83-.45c12.27-1.65,12.27-1.65,12.27,10.42V193.88h193.47V63h12.75V346.07H1068v-139H874.41V346.2H861.29Z",
    transform: "translate(-109 -12.63)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2093,62.89h13.17v6.58q0,83.48,0,167c0,15.89,1.48,31.61,6.77,46.73,11.39,32.52,34.79,50.19,68.47,54.84a115.63,115.63,0,0,0,45.63-2.4c34.38-9.07,53.1-32.66,59.81-66.47a174.25,174.25,0,0,0,3-32.74c.29-55.66.13-111.31.13-167V63.06h12.72a22.39,22.39,0,0,1,.42,3c-.06,61.49,0,123-.35,184.46a116.45,116.45,0,0,1-9.47,44.17c-11.2,26.79-30.79,44.31-58.68,52.13a132.58,132.58,0,0,1-71.08.48c-36.61-9.79-57.85-34.6-66.29-70.71a154.16,154.16,0,0,1-4.06-33.61c-.4-58.49-.2-117-.21-175.46Z",
    transform: "translate(-109 -12.63)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1641.47,75.1h-95.11V63h204.18v12h-95.48V345.5c-.72.46-1,.75-1.28.79-12.31,1.34-12.31,1.34-12.31-10.9V75.1Z",
    transform: "translate(-109 -12.63)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M581.45,62.88h204.2v12H690.27V346.09H677V75.19H581.45Z",
    transform: "translate(-109 -12.63)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.9,54.59,267.84,179.5l-.2.15L187.12,100.3C196,85.13,204.89,70,213.9,54.59Z",
    transform: "translate(-109 -12.63)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.5,186.79l-135,15.76c8.79-15.43,17.46-30.67,26.2-46l108.85,30Z",
    transform: "translate(-109 -12.63)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.67,104.54,262,180.84l-.1.21L157.15,152.2Z",
    transform: "translate(-109 -12.63)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M134.24,111.5c.3.73.55,1.33.78,1.92q7.75,19.78,15.5,39.55a2,2,0,0,1-.08,1.92Q137.68,176.91,125,199c-.17.3-.35.59-.62,1-.17-.42-.3-.71-.4-1q-7-22.05-14-44.1a1.91,1.91,0,0,1,.18-1.72q11.78-20.32,23.52-40.68C133.78,112.17,134,111.9,134.24,111.5Z",
    transform: "translate(-109 -12.63)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M209.6,52.29c-.24.46-.37.76-.54,1q-12.72,22-25.44,44.09a1.84,1.84,0,0,1-1.49,1c-5.36.78-10.71,1.62-16.06,2.43l-17.53,2.65L139,105a7.84,7.84,0,0,1-1,0c.22-.43.38-.77.57-1.09q11.64-20.2,23.29-40.41a2,2,0,0,1,1.49-1.09q22.26-4.87,44.52-9.79C208.37,52.51,208.9,52.42,209.6,52.29Z",
    transform: "translate(-109 -12.63)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154,148.66l-15.28-38.83L180,103.6Z",
    transform: "translate(-109 -12.63)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M340.78,222.77,475.63,207c-.21.89-24.94,44.47-26.07,46L340.75,223Z",
    transform: "translate(-109 -12.63)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M417.21,309.25l-26.56,45.38h-.18a.15.15,0,0,1-.1,0c-.09-.17-.2-.33-.27-.5L336.54,230.16c.07-.11.09-.15.12-.16a.15.15,0,0,1,.11,0c.12.09.24.18.35.28Z",
    transform: "translate(-109 -12.63)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M342.41,228.5l104.77,28.85L419.7,305l-77.41-76.3Z",
    transform: "translate(-109 -12.63)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M480.05,209.5c.59,1.81,1.11,3.42,1.62,5q6.36,20,12.73,40.06a2.16,2.16,0,0,1-.21,1.93q-11.69,20.21-23.33,40.41c-.19.33-.4.65-.69,1.11-.17-.37-.3-.61-.4-.87q-8-20.37-16-40.74a1.74,1.74,0,0,1,.1-1.71q12.81-22.14,25.58-44.3Z",
    transform: "translate(-109 -12.63)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.78,357.22c.25-.47.4-.77.57-1.06q12.67-22,25.35-44a2,2,0,0,1,1.59-1.09c5.35-.77,10.7-1.61,16-2.42l19.12-2.9c2.65-.41,5.3-.82,8-1.21a6.75,6.75,0,0,1,.92,0c-.18.36-.31.66-.47.94q-11.72,20.31-23.41,40.6a1.86,1.86,0,0,1-1.28,1q-22.87,5-45.74,10C395.29,357.18,395.14,357.18,394.78,357.22Z",
    transform: "translate(-109 -12.63)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M465.62,299.73l-41.27,6.21,26-45.06C455.47,273.93,460.5,286.73,465.62,299.73Z",
    transform: "translate(-109 -12.63)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M495.13,155.33c-.17.45-.35.89-.5,1.35q-6.86,21.62-13.73,43.23c-.08.25-.18.49-.32.86a7.59,7.59,0,0,1-.51-.66q-12.85-22.25-25.71-44.47a1.65,1.65,0,0,1-.1-1.61q8-20.35,16-40.71c.09-.24.21-.48.38-.85a8.38,8.38,0,0,1,.5.7q11.7,20.25,23.38,40.5c.19.32.39.64.59,1Z",
    transform: "translate(-109 -12.63)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M391,55.51c9,15.32,17.82,30.43,26.74,45.66l-80.54,79.41-.2-.12Z",
    transform: "translate(-109 -12.63)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M476.11,203.38l-134.93-15.7c.88-.54,105.79-29.55,109.05-30.19q13,22.78,26,45.64Z",
    transform: "translate(-109 -12.63)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M420.25,105.54l27.5,47.59L343,182C343.47,181.07,416.68,108.64,420.25,105.54Z",
    transform: "translate(-109 -12.63)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M395.2,53.12l3.62.78q21.35,4.71,42.71,9.39a2.06,2.06,0,0,1,1.48,1.1l23.35,40.5c.17.29.32.6.54,1a4.83,4.83,0,0,1-.6,0l-23.56-3.59c-6.67-1-13.35-2-20-3a1.74,1.74,0,0,1-1.42-.95q-12.74-22.09-25.51-44.18C395.63,53.93,395.49,53.66,395.2,53.12Z",
    transform: "translate(-109 -12.63)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.73,149.31,424.9,104.62c3.62.43,7,1,10.37,1.5s6.83,1,10.25,1.53,6.83,1,10.25,1.56l10.37,1.56L451,149.32Z",
    transform: "translate(-109 -12.63)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109,254.45a8.86,8.86,0,0,0,.65-1.31q5.58-17.55,11.13-35.11c.89-2.82,1.79-5.63,2.69-8.45a8.22,8.22,0,0,1,.35-.84c.27.44.48.75.66,1.08q12.66,21.88,25.31,43.76a2.28,2.28,0,0,1,.18,2.24Q142,276,134.15,296.11l-.44,1c-.31-.5-.55-.86-.76-1.24q-11.52-19.95-23-39.9a8.43,8.43,0,0,0-.91-1.1Z",
    transform: "translate(-109 -12.63)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M213.39,354.05l-26.78-45.67L267.17,229l.19.12Q240.44,291.42,213.39,354.05Z",
    transform: "translate(-109 -12.63)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M154.14,252.12l-26.19-46,135.2,15.73v.24Z",
    transform: "translate(-109 -12.63)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.05,304q-13.71-23.74-27.31-47.26a1.19,1.19,0,0,1,.06-.22.14.14,0,0,1,.07-.08c.21-.08.43-.17.65-.23l103.94-28.63C261,228.33,185.45,302.91,184.05,304Z",
    transform: "translate(-109 -12.63)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.44,303.55l3.76.54,28.68,4.36c4,.6,8,1.23,12,1.8a1.65,1.65,0,0,1,1.26,1q3.9,6.78,7.83,13.56l17.52,30.31c.19.33.37.67.63,1.15a7.24,7.24,0,0,1-.93-.07l-27.32-6c-5.85-1.29-11.69-2.59-17.54-3.83a3,3,0,0,1-2.18-1.59q-10.54-18.37-21.16-36.72l-2.07-3.59C137.73,304.22,137.62,304,137.44,303.55Z",
    transform: "translate(-109 -12.63)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.5,260c8.67,15,17.25,29.85,26,44.94-13.87-2.05-27.46-4.12-41-6.17C138.48,297.94,152,263.26,153.5,260Z",
    transform: "translate(-109 -12.63)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M305.41,396.91a9.7,9.7,0,0,1,.61-1q13.58-17,27.17-34a1.63,1.63,0,0,1,1.43-.75q25.75,0,51.51,0c.19,0,.38,0,.74.05-.27.35-.45.61-.67.85l-31,33.94c-.25.28-.45.6-.67.9Z",
    transform: "translate(-109 -12.63)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M248.93,396.91,238.07,385q-10.42-11.4-20.84-22.79c-.23-.25-.45-.52-.72-.82.4-.33.83-.2,1.22-.2h19.82q15.39,0,30.77,0a2.17,2.17,0,0,1,1.92.92q13.45,16.9,27,33.78a7.83,7.83,0,0,1,.6,1.06Z",
    transform: "translate(-109 -12.63)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.69,247.17q-14.24,54.66-28.52,109.45l-52.62-.33a.75.75,0,0,1-.08-.14.21.21,0,0,1,0-.11c.16-.25.32-.52.5-.76l80.52-108.2Z",
    transform: "translate(-109 -12.63)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.07,356.28l-52.94.33q-14.28-54.8-28.51-109.37l.23-.12Z",
    transform: "translate(-109 -12.63)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.13,356.52l27.39-105h.21q13.66,52.46,27.36,105Z",
    transform: "translate(-109 -12.63)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M301.57,393.67c-8.63-10.8-17.19-21.53-25.88-32.42h51.64C327,362,303,392.24,301.57,393.67Z",
    transform: "translate(-109 -12.63)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M299,12.63c-.23.35-.43.72-.69,1q-13.47,16.88-26.93,33.76a2.31,2.31,0,0,1-2,1q-25.29,0-50.57,0h-1.33c.34-.42.53-.69.75-.93q15.39-16.83,30.78-33.66c.33-.36.61-.77.91-1.16Z",
    transform: "translate(-109 -12.63)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M355.43,12.63c.87,1,1.72,2,2.6,2.92L387,47.18c.29.3.56.62.88,1-.41.33-.84.2-1.22.2H364.72q-14.34,0-28.68,0a2.16,2.16,0,0,1-1.94-.9q-13.52-17-27.09-33.93c-.24-.3-.45-.62-.68-.93Z",
    transform: "translate(-109 -12.63)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M388,53.5l-81.12,109-.2-.1Q320.88,107.75,335.15,53c17.57,0,35.1.25,52.64.27Z",
    transform: "translate(-109 -12.63)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M298.5,162.46,217.32,53.35c.46,0,.74-.1,1-.1l9.33,0,18.21-.11L266.75,53h3.47l28.5,109.38Z",
    transform: "translate(-109 -12.63)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M302.6,158.05Q289,105.61,275.28,53.16c.86-.25,53.33-.32,54.92-.08l-27.36,105Z",
    transform: "translate(-109 -12.63)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M328.68,48.34h-51.6a.39.39,0,0,1-.05-.14.17.17,0,0,1,0-.1c.2-.29.39-.57.61-.84L302.71,15.8Z",
    transform: "translate(-109 -12.63)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTtgLogo);
export default __webpack_public_path__ + "static/media/TTG-logo.7ab3f40f19312a36b8585caf93feae2a.svg";
export { ForwardRef as ReactComponent };